import { withInstall } from '@code-monkey-ui/utils'
import Switch from './src/switch.vue'

export const ElSwitch = withInstall(Switch)
export default ElSwitch

export * from './src/switch'
